import React, { useState } from 'react';
import { Modal, Checkbox, message } from 'antd';

interface ApproveModalProps {
    visible: boolean;
    fileId: number | null;
    onClose: () => void;
    onSuccess: () => void;
}

const ApproveModal: React.FC<ApproveModalProps> = ({ visible, fileId, onClose, onSuccess }) => {
    const [isOverride, setIsOverride] = useState(false);
    const [isSkip, setIsSkip] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleApprove = async () => {
        if (!fileId) return;
        
        setLoading(true);
        try {
            const token = localStorage.getItem("loginToken");
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/file/approve-file?fileId=${fileId}&isOverride=${isOverride}&isSkip=${isSkip}`,
                {
                    method: 'POST',
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );
            
            if (response.ok) {
                message.success('File approved successfully!');
                onSuccess();
                onClose();
                setIsOverride(false);
                setIsSkip(false);
            } else {
                message.error('Failed to approve file');
            }
        } catch (error) {
            console.error(error);
            message.error('Error approving file');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Approve File"
            open={visible}
            onCancel={onClose}
            onOk={handleApprove}
            okText="Approve"
            confirmLoading={loading}
        >
             <p>Are you sure you want to Approve this file?</p>
            {/* <div style={{ marginBottom: 16 }}>
                <Checkbox checked={isOverride} onChange={(e) => setIsOverride(e.target.checked)}>
                    Override
                </Checkbox>
            </div>
            <div>
                <Checkbox checked={isSkip} onChange={(e) => setIsSkip(e.target.checked)}>
                    Skip
                </Checkbox>
            </div> */}
        </Modal>
    );
};

export default ApproveModal;
